import { render } from "./button.vue?vue&type=template&id=bc0bb38a&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=bc0bb38a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc0bb38a"],['__file',"src/views/vab/form/button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc0bb38a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc0bb38a', __exports__)) {
    console.log('reload')
    api.reload('bc0bb38a', __exports__)
  }
  
  module.hot.accept("./button.vue?vue&type=template&id=bc0bb38a&scoped=true", () => {
    console.log('re-render')
    api.rerender('bc0bb38a', render)
  })

}


export default __exports__